module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "forgot-password-box"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    attrs: {
      "id": "forgot-password-content"
    }
  }, [_c('ul', {
    staticClass: "reset-type list-unstyled"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.isShowResetPhonePwd = false
      }
    }
  }, [_c('a', {
    class: {
      'active': !_vm.isShowResetPhonePwd
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t('email')))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.isShowResetPhonePwd = true
      }
    }
  }, [_c('a', {
    class: {
      'active': _vm.isShowResetPhonePwd
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t('phone')))])])]), _vm._v(" "), _c('forgot-email-pwd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowResetPhonePwd),
      expression: "!isShowResetPhonePwd"
    }],
    staticClass: "email-phone-reset"
  }), _vm._v(" "), _c('reset-phone-pwd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowResetPhonePwd),
      expression: "isShowResetPhonePwd"
    }],
    staticClass: "email-phone-reset"
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2df982c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgotpwd/forgotPwd/ForgotPwd.vue
// module id = 1403
// module chunks = 1